import { useMemo } from 'react';
import { SignIn } from '@clerk/clerk-react';

const SALESFORCE_URL = 'https://bluwavelp.my.salesforce.com/';

const clerkAppearance = {
  variables: {
    colorPrimary: '#0d9488',
    colorTextOnPrimaryBackground: '#f0f9ff',
    colorBackground: 'rgba(8, 47, 73, 0.45)',
    colorInputBackground: 'rgba(224, 242, 254, 0.12)',
    colorInputText: '#e0f2fe',
    colorText: '#bae6fd',
    colorTextSecondary: '#7dd3fc',
    colorNeutral: '#164e63',
    borderRadius: '0.75rem',
  },
  elements: {
    card: {
      background: 'rgba(7, 42, 66, 0.50)',
      backdropFilter: 'blur(16px)',
      WebkitBackdropFilter: 'blur(16px)',
      border: '1px solid rgba(125, 211, 252, 0.2)',
      boxShadow: '0 8px 32px rgba(0, 0, 0, 0.4)',
    },
    headerTitle: {
      color: '#7dd3fc',
      textShadow: '0 1px 8px rgba(0,0,0,0.5)',
    },
    headerSubtitle: { color: '#a5f3fc' },
    formFieldLabel: { color: '#67e8f9' },
    formFieldInput: {
      background: 'rgba(224, 242, 254, 0.08)',
      border: '1px solid rgba(103, 232, 249, 0.3)',
      color: '#e0f2fe',
    },
    formButtonPrimary: {
      background: 'linear-gradient(135deg, #0e7490, #0d9488)',
      color: '#f0f9ff',
    },
    footerActionLink: { color: '#2dd4bf' },
    identityPreviewText: { color: '#bae6fd' },
    dividerLine: { background: 'rgba(125, 211, 252, 0.2)' },
    dividerText: { color: '#7dd3fc' },
    formFieldErrorText: { color: '#7dd3fc' },
    footer: { display: 'none' },
  },
};

export default function HomePage() {
  const returnLink = useMemo(() => {
    try {
      const referrer = document.referrer;
      if (referrer) {
        const url = new URL(referrer);
        if (url.pathname === '/one-pager') {
          return { href: '/one-pager', label: 'return to the One Pager' };
        }
      }
    } catch {
      // ignore
    }
    return { href: SALESFORCE_URL, label: 'return to Salesforce' };
  }, []);

  return (
    <div
      className="flex min-h-screen flex-col items-center justify-center gap-3"
      style={{
        backgroundImage: 'url(/anchor_backdrop.png)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}
    >
      <SignIn routing="hash" appearance={clerkAppearance} />
      <p className="text-sm" style={{ color: '#7dd3fc' }}>
        Not sure how to sign in?{' '}
        <a
          href={returnLink.href}
          className="underline underline-offset-2 hover:opacity-80"
          style={{ color: '#2dd4bf' }}
        >
          Click here
        </a>
        {' '}to {returnLink.label}.
      </p>
    </div>
  );
}
